import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}`;
const COUNT_ARTICLE = `${MAIN_URL}/v1/adminArticles/countArticles`;
const COUNT_USER = `${MAIN_URL}/userDatabase/countUsers`;
const AUDIT_STATS = `${MAIN_URL}/v1/adminPortal/auditLogs/stats`;
const RECENT_AUDIT_LOGS = `${MAIN_URL}/v1/adminPortal/auditLogs?limit=5`;

export async function getArticleCount(token) {
  try {
    const response = await axios.get(COUNT_ARTICLE, {
      headers: { token },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching articles:", error);
    return { Result: false, Msg: "Error fetching articles" };
  }
}

export async function getUserCount(token) {
  try {
    const response = await axios.get(COUNT_USER, {
      headers: { token },
      withCredentials: true, 
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching User Count:", error);
    return { Result: false, Msg: "Error fetching User Count" };
  }
}

export async function getAuditStats(token) {
  try {
    const response = await axios.get(AUDIT_STATS, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    return { Result: false };
  }
}

export async function getRecentAuditLogs(token) {
  try {
    const response = await axios.get(RECENT_AUDIT_LOGS, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    return { Result: false };
  }
}
